import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import WaybillDataModalBody from '../components/WaybillData/WaybillDataModalBody';
import * as waybillDataActions from '../actions/WaybillData'; 

class WaybillData extends React.Component {

    onFormSubmit = (waybillData) => {
        this.props.updateComplaintWaybillData(this.props.modalProps.complaintId, waybillData.newNumber, waybillData.waybillCourier);
    }

    onDismissButtonClick = () => this.props.hideModal();

    onWaybillNumberChange = (e) => this.props.updateNewWaybillNumberValue(e.target.value);

    onWaybillCourierChange = (e) => {
        let courier = this.props.couriers.find(item=> item.value ===e.target.options[e.target.selectedIndex].value);
        this.props.updateWaybillDataCourier(courier);
    }

    render() {
        return(
            <WaybillDataModalBody
                onFormSubmit={this.onFormSubmit}
                actualWaybillCourier={this.props.modalProps.waybillCourier}
                actualWaybillNumber={this.props.modalProps.waybillNumber}
                couriers={this.props.couriers}
                onWaybillCourierChange={this.onWaybillCourierChange}
                onWaybillNumberChange={this.onWaybillNumberChange}
                waybillData={this.props.waybillData}
                onDismissButtonClick={this.onDismissButtonClick} />
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        hideModal: () => dispatch(waybillDataActions.closeUpdateWaybillDataModal()),
        updateNewWaybillNumberValue: (waybillNumber) => dispatch(waybillDataActions.updateNewWaybillNumberValue(waybillNumber)),
        updateComplaintWaybillData: (complaintId, waybillNumber, waybillCourier) => dispatch(waybillDataActions.updateComplaintWaybillData(complaintId, waybillNumber,waybillCourier)),
        updateWaybillDataCourier: (courier) => dispatch(waybillDataActions.updateWaybillDataCourier(courier))
    };
};

const mapStateToProps = (state) => {
    return {
        waybillData: state.waybillData,
        modalProps: state.modal.modalProps,
        couriers: state.util.couriers
    };
};

WaybillData.propTypes = {
    //Function triggered after form submit
    updateComplaintWaybillData: PropTypes.func,
    //Props for modal
    modalProps: PropTypes.shape({
        complaintId: PropTypes.number,
        waybillNumber: PropTypes.string,
        waybillCourier: PropTypes.object
    }),
    //Close modal function
    hideModal: PropTypes.func,
    //Function which update waybill number value
    updateNewWaybillNumberValue: PropTypes.func,
    //Couriers
    couriers: PropTypes.array,
    //Function which update waybill courier value
    updateWaybillDataCourier: PropTypes.func,
    waybillData: PropTypes.object
};

export default connect(mapStateToProps,mapDispatchToProps)(WaybillData);


// WEBPACK FOOTER //
// ./src/containers/WaybillData.js